import { PAC_ACCOUNT_TYPE_ENUM } from '@core/enums/pac-account-type.enum';

export const PacAccountTypesValue = [
  PAC_ACCOUNT_TYPE_ENUM.POST_ACUTE_FACILITY,
  PAC_ACCOUNT_TYPE_ENUM.HOSPITAL_CM_DISCHARGE_PLANNER
];
